import { GetCombinedItemQuery } from '../getCombinedItemQuery';
import { PatchBulkUpdateCombinedItem } from './patchBulkUpdateCombinedItem';

export enum BulkUpdateCombinedItemType {
    PATCH = 'patch',
    CREATE = 'create',
}

export class BulkUpdateCombinedItemQueryUpdate {
    includedItems?: string[];

    excludedItems?: string[];

    searchQuery?: GetCombinedItemQuery;

    data: PatchBulkUpdateCombinedItem;

    type: BulkUpdateCombinedItemType;
}
